export const AUTH_STATE_COOKIE_NAME = 'oauth_state';
export const AUTH_CODE_PARAM = 'code';
export const AUTH_STORAGE_KEY = 'auth';
export const AUTH_TRIGGER_POST_LOGIN = 'authTriggerPostLogin';
export const AUTH_STORAGE_EXPIRY = 5 * 24 * 60 * 60 * 1000;
